import React, { useCallback, useState } from 'react';

import { Icons, Modal } from '@components/common';
import TextAvatar from '@components/common/TextAvatar';
import OrganisationInfo from '@components/ModalComponents/OrganisationInfo';

import { useQueryOrganisationProfileById } from '@hooks/organisation/useQueryOrganisationProfile';

import colors from '@constants/colors';

import commonStyles from '@styles/common.module.scss';

import styles from '../RequestReservationCard.module.scss';

interface IRequesterBlockProps {
	companyName?: string;
	user: {
		email: string;
		id: string;
		fullName: string;
	};
	isAO: boolean;
	mnoId: string;
	assetOwnerId: string;
}

const RequesterBlock = ({ companyName, user, isAO, mnoId, assetOwnerId }: IRequesterBlockProps) => {
	const { profile } = useQueryOrganisationProfileById(isAO ? mnoId : assetOwnerId);

	const [isOrganisationInfoWindow, setIsOrganisationInfoWindow] = useState(false);

	const toggleOrganisationInfo = useCallback(() => {
		setIsOrganisationInfoWindow(prevState => !prevState);
	}, []);

	return (
		<div className={styles.requesterBlock}>
			<div className={styles.requesterAvatar}>
				<TextAvatar
					avatarColor={colors.gray20}
					avatarId={profile?.avatar?.id}
					className={styles.logo}
					fontSize='20px'
					fullName={user?.fullName}
					id={user?.id}
					isProfileLogo
					size='75px'
				/>
			</div>
			<div className={styles.requesterDescription}>
				<div className={styles.requesterDescriptionTitle}>
					<span className={styles.requestParamName}>{companyName}</span>
					<span
						className={commonStyles.infoIcon}
						onClick={toggleOrganisationInfo}
					>
						{Icons.info()}
					</span>
				</div>
				{isAO
					&& <>
						<div className={styles.requesterParamItem}>
							<div className={styles.requesterParamIcon}>{Icons.usersIcon()}</div>
							<span className={styles.requesterParamValue}>{`${user.fullName}`}</span>
						</div>
						<div className={styles.requesterParamItem}>
							<div className={styles.requesterParamIcon}>{Icons.emailIcon()}</div>
							<span className={styles.requesterParamValue}>{user?.email}</span>
						</div>
					</>
				}
			</div>
			<Modal
				isOpen={isOrganisationInfoWindow}
				isScrollableContent
				isTitleHidden
				onClose={toggleOrganisationInfo}
				width='640px'
			>
				<OrganisationInfo id={isAO ? mnoId : assetOwnerId} />
			</Modal>
		</div>
	);
};

export default RequesterBlock;
